import React from 'react';

interface PlusCircleIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const PlusCircleIcon: React.FC<PlusCircleIconProps> = ({ 
  width = 14, 
  height = 13, 
  color = '#161616',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 14 13"
      className={className}
      style={style}
    >
      <path 
        d="M12.6001 6.49984C12.6001 3.40704 10.0926 0.899577 6.99984 0.899577C3.90704 0.899577 1.39958 3.40704 1.39958 6.49984C1.39958 9.59263 3.90704 12.1001 6.99984 12.1001C10.0926 12.1001 12.6001 9.59263 12.6001 6.49984ZM6.6001 9.1665V6.89958H4.33317C4.11226 6.89958 3.93343 6.72075 3.93343 6.49984C3.93343 6.27892 4.11226 6.1001 4.33317 6.1001H6.6001V3.83317C6.6001 3.61226 6.77892 3.43343 6.99984 3.43343C7.22075 3.43343 7.39958 3.61226 7.39958 3.83317V6.1001H9.6665C9.88742 6.1001 10.0662 6.27892 10.0662 6.49984C10.0662 6.72075 9.88742 6.89958 9.6665 6.89958H7.39958V9.1665C7.39958 9.38742 7.22075 9.56624 6.99984 9.56624C6.77892 9.56624 6.6001 9.38742 6.6001 9.1665ZM13.3996 6.49984C13.3996 10.0345 10.5345 12.8996 6.99984 12.8996C3.46521 12.8996 0.600098 10.0345 0.600098 6.49984C0.600098 2.96521 3.46521 0.100098 6.99984 0.100098C10.5345 0.100098 13.3996 2.96521 13.3996 6.49984Z" 
        fill={color}
      />
    </svg>
  );
};

export default PlusCircleIcon;

